// ============================================
// BulkJobApply Demo OS — Configuration
// ============================================
// Edit credentials and settings here.
// No other files need to change.
// ============================================

const CLOSER_ACCOUNTS_RAW = process.env.REACT_APP_CLOSER_ACCOUNTS;

export const CLOSER_ACCOUNTS = CLOSER_ACCOUNTS_RAW
  ? JSON.parse(CLOSER_ACCOUNTS_RAW)
  : [
    { username: "closer1", password: "bja2024", name: "Abdul" },
    { username: "closer2", password: "bja2024b", name: "Priya" },
    { username: "admin", password: "bjadmin", name: "Shubham" },
  ];

export const PLAN_DATA = {
  "1-month-full-stack": {
    name: "Full Stack — 1 Month",
    price: "$399",
    priceNum: 399,
    period: "per month",
    oneLiner: "780 apps + full team + automation",
    features: [
      "780 human applications",
      "Full team on WhatsApp",
      "ChillApply + ChillRefer automation",
    ],
  },
  "2-month-full-stack": {
    name: "Full Stack — 2 Months",
    price: "$625",
    priceNum: 625,
    period: "one-time",
    badge: "Most Popular",
    oneLiner: "Most clients land their offer in weeks 5–8.",
    description:
      "Month 1 builds your pipeline. Month 2 is where interviews happen. Most clients land in weeks 5–8. Two months is how long a real job search takes when done right.",
    features: [
      "1,560 human applications",
      "Full team on WhatsApp",
      "ChillApply + ChillRefer automation",
      "Most clients who land do it in this plan.",
    ],
  },
  "guaranteed": {
    name: "Guaranteed — 10 Interviews",
    price: "$1,499",
    priceNum: 1499,
    period: "one-time",
    splitPayment: "$750 today — $750 after your first interview",
    oneLiner: "10 interviews guaranteed. No time limit. Unlimited applications.",
    description:
      "Pay half now. Pay the rest only when we book your first interview. We keep applying until you have 10 interviews. No time limit. No risk.",
    features: [
      "Work until 10 interviews",
      "No time limit — unlimited duration",
      "Unlimited applications",
    ],
  },
  /* ─── Demo 2 plans (v6+) ─── */
  "chillrefer-99": {
    name: "ChillRefer",
    price: "$99 / month",
    priceNum: 99,
    period: "monthly",
    oneLiner: "Automation only. Cancel anytime.",
    description:
      "600+ personalized recruiter and hiring-manager outreaches every month, AI-drafted with your approval, auto follow-ups, live kanban CRM. No human team. No guarantee. Cancel anytime.",
    features: [
      "600+ personalized recruiter outreaches / month",
      "AI-drafted messages, you stay in control",
      "Auto follow-ups every 24h",
      "Live kanban CRM tracking every conversation",
    ],
  },
  "hired-in-90": {
    name: "Hired in 90",
    price: "$1,499",
    priceNum: 1499,
    period: "total · 2 ways to pay",
    badge: "Most Popular",
    splitPayment: "$750 today + $750 after first interview · or pay $1,299 in full",
    oneLiner: "Real humans + AI + interview guarantee.",
    description:
      "Our complete 90-day done-for-you system. Real human team applying, AI running referrals, full LinkedIn rebuild — guaranteed 10 interviews in 90 days, or 1 year of ChillRefer free until you land.",
    features: [
      "Real human application team — up to 780 appl. / month",
      "1:1 Personal Closer Coach",
      "Resume rebuild in 48 hours + ATS-friendly",
      "ChillRefer + ChillApply running in parallel",
      "The Hired-in-90 Promise — 10 interviews in 90 days, or 1 year ChillRefer free",
    ],
  },
};

export const AUTH_KEY = "bja_auth";
export const LEADS_KEY = "bja_leads";
export const SETTINGS_KEY = "bja_settings";

export function getAuth() {
  try {
    const data = JSON.parse(localStorage.getItem(AUTH_KEY));
    if (data && data.loggedIn) return data;
  } catch (e) {
    console.error("Failed to parse auth data:", e);
  }
  return null;
}

export function setAuth(user) {
  localStorage.setItem(AUTH_KEY, JSON.stringify({ ...user, loggedIn: true }));
}

export function clearAuth() {
  localStorage.removeItem(AUTH_KEY);
}

const API = process.env.REACT_APP_BACKEND_URL || "";

export function getLeads() {
  try {
    return JSON.parse(localStorage.getItem(LEADS_KEY)) || [];
  } catch (e) {
    console.error("Failed to parse leads data:", e);
    return [];
  }
}

export function saveLeads(leads) {
  localStorage.setItem(LEADS_KEY, JSON.stringify(leads));
  // Background sync to MongoDB
  fetch(`${API}/api/demo/leads/bulk`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ leads }),
  }).catch((e) => console.error("Background sync leads failed:", e));
}

const DEFAULT_SETTINGS = {
  fathomApiKey: "p-fSl2PWK4iOjSS-zfiwVg.uz-HhdMkw4w1CwSlCfkjFdRC54M2fKiGVC4zpC6mUss",
  fathomWebhookSecret: "whsec_bbbR1SR0v/d06gxhgPDT2WmYBfmCWWF/",
};

export function getSettings() {
  try {
    const saved = JSON.parse(localStorage.getItem(SETTINGS_KEY)) || {};
    return { ...DEFAULT_SETTINGS, ...saved };
  } catch (e) {
    console.error("Failed to parse settings data:", e);
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(settings) {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  // Background sync to MongoDB
  fetch(`${API}/api/demo/settings`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(settings),
  }).catch((e) => console.error("Background sync settings failed:", e));
}

// Pull latest from MongoDB and update localStorage cache
export async function syncFromDB() {
  try {
    // Seed if needed
    await fetch(`${API}/api/demo/leads/seed`, { method: "POST" });
    // Fetch leads
    const leadsResp = await fetch(`${API}/api/demo/leads`);
    if (leadsResp.ok) {
      const data = await leadsResp.json();
      const dbLeads = data.leads || [];
      if (dbLeads.length > 0) {
        localStorage.setItem(LEADS_KEY, JSON.stringify(dbLeads));
      }
    }
    // Fetch settings
    const settingsResp = await fetch(`${API}/api/demo/settings`);
    if (settingsResp.ok) {
      const dbSettings = await settingsResp.json();
      if (Object.keys(dbSettings).length > 0) {
        const merged = { ...DEFAULT_SETTINGS, ...dbSettings };
        localStorage.setItem(SETTINGS_KEY, JSON.stringify(merged));
      }
    }
  } catch (e) {
    console.error("syncFromDB failed:", e);
  }
}

export function getActionSuggestion(lead) {
  const now = new Date();

  if (lead.status === "converted") {
    return { color: "green", text: "Active client — no action needed" };
  }

  if (lead.status === "cold") {
    return { color: "gray", text: "Cold — no action" };
  }

  if (lead.status === "upcoming" || lead.status === "demo_in_progress") {
    const scheduled = new Date(lead.scheduledAt);
    const minsUntil = (scheduled - now) / (1000 * 60);
    if (minsUntil <= 60 && minsUntil > 0) {
      return { color: "yellow", text: "Send show-up message now" };
    }
    if (minsUntil <= 24 * 60 && minsUntil > 0) {
      return { color: "gray", text: "Send show-up message today" };
    }
    if (minsUntil <= 0) {
      return { color: "yellow", text: "Demo time — start when ready" };
    }
    return { color: "gray", text: "Demo scheduled" };
  }

  if (lead.status === "payment_sent") {
    const daysSince = Math.floor(
      (now - new Date(lead.paymentSentAt)) / (1000 * 60 * 60 * 24)
    );
    if (daysSince <= 1) {
      return { color: "orange", text: "Confirm payment received" };
    }
    return { color: "red", text: "Chase payment — resend link" };
  }

  if (lead.status === "demo_done") {
    const daysSince = Math.floor(
      (now - new Date(lead.demoDoneAt)) / (1000 * 60 * 60 * 24)
    );
    if (daysSince === 0) return { color: "red", text: "Send follow-up NOW — within 5 mins" };
    if (daysSince === 1) return { color: "orange", text: "Check in: 'Any questions I can answer?'" };
    if (daysSince <= 3) return { color: "orange", text: `Send case study for ${lead.targetRole}` };
    if (daysSince <= 5) return { color: "yellow", text: "Send scarcity: spot opening this week" };
    if (daysSince <= 7) return { color: "gray", text: "Final close: 10% discount, 24h" };
    return { color: "gray", text: "Mark cold if no response" };
  }

  return { color: "gray", text: "" };
}

export function recommendPlan(lead) {
  if (lead.monthsSearching >= 4) return "guaranteed";
  if (!lead.monthsSearching || lead.monthsSearching < 1) return "1-month-full-stack";
  return "2-month-full-stack";
}

export function generateShowUpMessage(lead, closerName, meetLink, time) {
  return `Hey ${lead.clientName}! 👋

We're all set for our call at ${time}.

Here's what we'll cover in ~15 mins:
✅ Why volume is the #1 factor in landing faster
✅ Real client results — I'll show you actual interview emails
✅ Exactly how BulkJobApply works for ${lead.targetRole} roles
✅ Pricing + which plan fits your situation

Join here: ${meetLink || "[link]"}

See you soon!
— ${closerName}, BulkJobApply`;
}

export function generateFollowUpMessage(lead, closerName, settings, painPoints = []) {
  const planKey = lead.recommendedPlan || recommendPlan(lead);
  const plan = PLAN_DATA[planKey];
  const paymentLink = settings?.razorpayLink || "[payment link]";

  let painLine = "";
  if (painPoints.length > 0) {
    painLine = `\nYou mentioned struggling with ${painPoints.slice(0, 3).join(", ").toLowerCase()} — that's exactly what we solve for our clients every day.\n`;
  }

  // Guaranteed plan: lead with the split-pay structure (de-risks the close)
  const priceLine = planKey === "guaranteed"
    ? `${plan.name} — $750 today, $750 after your first interview (total ${plan.price})`
    : `${plan.name} — ${plan.price}`;

  return `Hey ${lead.clientName}! Great speaking with you just now.
${painLine}
As discussed — based on your search for ${lead.targetRole} roles in ${lead.targetMarket}, here's what I'd recommend:

${priceLine}

That gets you:
✅ ${plan.features[0]}
✅ ${plan.features[1]}
✅ ${plan.features[2]}

Payment link: ${paymentLink}

Once paid, we'll have your WhatsApp group set up within the hour and applications start Day 3.

Any questions, just reply here.

— ${closerName}, BulkJobApply`;
}

export const FOLLOW_UP_TEMPLATES = {
  immediate: {
    label: "Immediate Follow-up",
    emoji: "🔥",
    desc: "Send within 5 mins of demo ending",
    generate: (lead, closerName, settings, painPoints) => generateFollowUpMessage(lead, closerName, settings, painPoints),
  },
  checkIn: {
    label: "Day 1 Check-in",
    emoji: "💬",
    desc: "Send next day if no reply",
    generate: (lead, closerName, settings, painPoints) => {
      let painRef = "";
      if (painPoints.length > 0) {
        painRef = ` I know ${painPoints[0].toLowerCase()} has been frustrating — we can start fixing that this week.`;
      }
      return `Hey ${lead.clientName}! Just checking in from our chat yesterday.

Any questions I can answer about the plan?${painRef}

Happy to hop on a quick 5-min call if that's easier.

— ${closerName}`;
    },
  },
  caseStudy: {
    label: "Case Study Push",
    emoji: "📊",
    desc: "Send day 2-3 with relevant proof",
    generate: (lead, closerName, settings, painPoints) => {
      const painRef = painPoints.length > 0 ? painPoints[0].toLowerCase() : "a competitive job market";
      return `Hey ${lead.clientName}! Thought you'd find this interesting —

One of our recent clients had the same challenge with ${painRef}. They signed up and within 3 weeks had 8 interview calls lined up.

The only difference? Volume. 780 tailored applications vs the 10-20 most people manage on their own.

Want me to walk you through their exact timeline? Or if you're ready, I can send the payment link right now.

— ${closerName}`;
    },
  },
  scarcity: {
    label: "Scarcity Message",
    emoji: "⏰",
    desc: "Send day 4-5 to create urgency",
    generate: (lead, closerName, settings) => {
      return `Hey ${lead.clientName}! Quick heads up —

We have a spot opening up this week on our ${lead.targetMarket} team. That means your applications could start going out by this Friday.

We only take on a limited number of clients per market to maintain quality. Once this spot fills, the next opening is in 2-3 weeks.

Want me to hold it for you? Just need the payment to confirm.

— ${closerName}`;
    },
  },
  finalOffer: {
    label: "Final Close",
    emoji: "🎯",
    desc: "Send day 5-7 as last push",
    generate: (lead, closerName, settings, painPoints) => {
      const planKey = lead.recommendedPlan || recommendPlan(lead);
      const plan = PLAN_DATA[planKey];
      let painRef = "";
      if (painPoints.length > 0) {
        painRef = `\nYou told me about ${painPoints.slice(0, 2).join(" and ").toLowerCase()} — every week that passes without action means more missed opportunities.\n`;
      }
      const priceCopy = planKey === "guaranteed"
        ? `${plan.name} — $750 today, $750 after your first interview (10% off the second half if you sign up in the next 24 hours)`
        : `${plan.name} from ${plan.price} to a special rate (10% early-bird off if you sign up in the next 24 hours)`;
      return `Hey ${lead.clientName}! I wanted to reach out one last time.
${painRef}
I can offer you something just for today — ${priceCopy}.

After tomorrow, the standard pricing applies and the current slot may no longer be available.

No pressure — just didn't want you to miss out.

— ${closerName}`;
    },
  },
};

// Sample leads for initial testing
export function seedSampleLeads() {
  const existing = getLeads();
  if (existing.length > 0) return;

  const now = new Date();
  const samples = [
    {
      id: crypto.randomUUID(),
      clientName: "Sarah",
      clientLastName: "K.",
      targetRole: "Product Manager",
      targetMarket: "United States",
      whatsappNumber: "+1234567890",
      scheduledAt: new Date(now.getTime() + 2 * 60 * 60 * 1000).toISOString(),
      closerUsername: "closer1",
      closerName: "Abdul",
      notes: "Referred by LinkedIn ad",
      status: "upcoming",
      demoDoneAt: null,
      weeklyApps: null,
      targetSalary: null,
      monthsSearching: null,
      recommendedPlan: null,
      followUpMessage: null,
      paymentSentAt: null,
      convertedAt: null,
      convertedAmount: null,
      createdAt: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: crypto.randomUUID(),
      clientName: "Raj",
      clientLastName: "M.",
      targetRole: "Software Engineer",
      targetMarket: "Germany",
      whatsappNumber: "+4912345678",
      scheduledAt: new Date(now.getTime() + 26 * 60 * 60 * 1000).toISOString(),
      closerUsername: "closer2",
      closerName: "Priya",
      notes: "",
      status: "upcoming",
      demoDoneAt: null,
      weeklyApps: null,
      targetSalary: null,
      monthsSearching: null,
      recommendedPlan: null,
      followUpMessage: null,
      paymentSentAt: null,
      convertedAt: null,
      convertedAmount: null,
      createdAt: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: crypto.randomUUID(),
      clientName: "Anita",
      clientLastName: "P.",
      targetRole: "Marketing Manager",
      targetMarket: "UAE",
      whatsappNumber: "+971501234567",
      scheduledAt: new Date(now.getTime() - 1 * 60 * 60 * 1000).toISOString(),
      closerUsername: "closer1",
      closerName: "Abdul",
      notes: "Very interested, asked about guarantee",
      status: "demo_done",
      demoDoneAt: new Date().toISOString(),
      weeklyApps: 12,
      targetSalary: 7000,
      monthsSearching: 2,
      recommendedPlan: "2-month-full-stack",
      followUpMessage: null,
      paymentSentAt: null,
      convertedAt: null,
      convertedAmount: null,
      createdAt: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: crypto.randomUUID(),
      clientName: "James",
      clientLastName: "W.",
      targetRole: "Data Analyst",
      targetMarket: "Canada",
      whatsappNumber: "+1987654321",
      scheduledAt: new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000).toISOString(),
      closerUsername: "admin",
      closerName: "Shubham",
      notes: "Needs to check with partner",
      status: "demo_done",
      demoDoneAt: new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000).toISOString(),
      weeklyApps: 8,
      targetSalary: 6000,
      monthsSearching: 4,
      recommendedPlan: "guaranteed",
      followUpMessage: null,
      paymentSentAt: null,
      convertedAt: null,
      convertedAmount: null,
      createdAt: new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: crypto.randomUUID(),
      clientName: "Lisa",
      clientLastName: "C.",
      targetRole: "HR Business Partner",
      targetMarket: "UK",
      whatsappNumber: "+447123456789",
      scheduledAt: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000).toISOString(),
      closerUsername: "closer2",
      closerName: "Priya",
      notes: "Payment link sent via WhatsApp",
      status: "payment_sent",
      demoDoneAt: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000).toISOString(),
      weeklyApps: 15,
      targetSalary: 5500,
      monthsSearching: 1,
      recommendedPlan: "1-month-full-stack",
      followUpMessage: null,
      paymentSentAt: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
      convertedAt: null,
      convertedAmount: null,
      createdAt: new Date(now.getTime() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    },
    {
      id: crypto.randomUUID(),
      clientName: "Mike",
      clientLastName: "T.",
      targetRole: "Operations Manager",
      targetMarket: "Australia",
      whatsappNumber: "+61412345678",
      scheduledAt: new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000).toISOString(),
      closerUsername: "closer1",
      closerName: "Abdul",
      notes: "Converted after 2-day follow up",
      status: "converted",
      demoDoneAt: new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000).toISOString(),
      weeklyApps: 20,
      targetSalary: 9000,
      monthsSearching: 3,
      recommendedPlan: "2-month-full-stack",
      followUpMessage: null,
      paymentSentAt: new Date(now.getTime() - 12 * 24 * 60 * 60 * 1000).toISOString(),
      convertedAt: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000).toISOString(),
      convertedAmount: 625,
      createdAt: new Date(now.getTime() - 20 * 24 * 60 * 60 * 1000).toISOString(),
    },
  ];

  saveLeads(samples);
}
